import React, { Component } from "react";
import styled from "styled-components";
import { FaBiking, FaStar, FaRegSmile } from "react-icons/fa";
import { MdFoodBank } from "react-icons/fa";
export default class Services extends Component {
  state = {
    services: [
      {
        id: 1,
        icon: <FaBiking />,
        title: "Udbringning",
        text: "Vi tilbyder ikke selv levering. Få din bestilling bragt til døren via Wolt eller Just-Eat. Find os på Wolt eller Just-Eat og bestil nemt!",
      },
      {
        id: 2,
        icon: <FaStar />,
        title: "Kvalitet",
        text: "Vi går meget op i både kvalitet og kundetilfredshed. Derfor bruger vi altid friske og nøje udvalgte råvarer, og vores retter bliver lavet med stor omhu – hver eneste gang. Vores pizzadej er baseret på ægte surdej, som giver en unik smag, bedre struktur og højere kvalitet i hver bid. Hos os får du mad, vi selv kan stå 100% inde for.",
      },
      {
        id: 3,
        icon: <FaRegSmile />,
        title: "Se vores smiley",
        text: (
          <span>
            Du kan her se på vores smiley.{" "}
            <a
              href="https://www.findsmiley.dk/114939"
              target="_blank"
              rel="noopener noreferrer"
            >
              Fødevarestyrelsen
            </a>
          </span>
        ),
      },
    ],
  };
  render() {
    return (
      <ServicesWrapper className="py-5 mb-5">
        <div className="container">
          <div className="row">
            {this.state.services.map((itme) => {
              return (
                <div
                  className="col-10 mx-auto col-sm-6 col-md-4 text-center my-3 mb-5"
                  key={itme.id}
                >
                  <div className="service-icon">{itme.icon}</div>
                  <div className="mt-3 text-capitalize">{itme.title}</div>
                  <div className="mt-3">{itme.text}</div>
                </div>
              );
            })}
          </div>
        </div>
      </ServicesWrapper>
    );
  }
}
const ServicesWrapper = styled.div`
  background: rgba(95, 183, 234, 0.5);
  .service-icon {
    font-size: 2.5rem;
    color: var(--primaryColor);
  }
`;
